import { render, staticRenderFns } from "./VacCard.vue?vue&type=template&id=4a052e22&scoped=true"
import script from "./VacCard.vue?vue&type=script&lang=js"
export * from "./VacCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a052e22",
  null
  
)

export default component.exports